import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { KetHeadersMenuComponent } from './headers-menu.component'
import { NzDropDownModule } from 'ng-zorro-antd/dropdown'
import { NzSwitchModule } from 'ng-zorro-antd/switch'
import { NzRadioModule } from 'ng-zorro-antd'
import { FormsModule } from '@angular/forms'
import { SortablejsModule } from 'ngx-sortablejs'
import { KetMoveLayerManuModule } from '../move-layer-manu'
import { KetAddMenuPageModule } from '../add-menu-page'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { KetPathLangModule } from '../path-lang'

@NgModule({
  declarations: [KetHeadersMenuComponent],
  entryComponents: [KetHeadersMenuComponent],
  imports: [
    CommonModule,
    NzRadioModule,
    FormsModule,
    SortablejsModule,
    NzDropDownModule,
    NzSwitchModule,
    KetMoveLayerManuModule,
    KetAddMenuPageModule,
    NzIconModule,
    KetPathLangModule
  ],
  exports: [KetHeadersMenuComponent],
})
export class KetHeadersMenuModule {}
